import { Injectable } from '@angular/core';
import { API_METHODS, API_URL, OperationType } from 'common/constants/sm-constants';

import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { StudentProfileModel, studentDetailsForm } from 'common/models/page-models/studentprofile/formmodel/studentprofile-form.data.model';
import { FormDataService } from '../base-data-services/form-data.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class StudentProfileFormDataService extends FormDataService<StudentProfileModel> {
  constructor(http: SmApiService, ss: SystemService) {
    super(API_URL.student_submit_details, http, ss);
  }

  // override getEditUrlAndMethod(id: any): editInfo {
  //     throw new Error("Method not implemented.");
  // }
  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.student_profile,
      method: API_METHODS.post,
      id_key_name: 'trainers_id',
    };
    this.multiapiCallData();
    return edit;
  }

  override getUpdatePayload(data: any) {
    let payload;
    payload = {
      id: JSON.parse(this.systemService.getlocalStorage('loginData')).id,
    };
    return payload;
  }

  multiapiCallData() {
    this.setSystemServiceData('batch_number', API_URL.batchList, ' ', 'details');
    this.setSystemServiceData('zone_name', API_URL.zoneList, ' ', 'details');
    this.setSystemServiceData('state_List', API_URL.stateList, ' ', 'details');
    this.setSystemServiceData('package_list', API_URL.getPackageList, ' ', 'details');
    this.setSystemServiceData('branch_list', API_URL.branchList, ' ', 'details');
    this.setSystemServiceData('document_type', API_URL.getDocumentTypeList, '', 'details');
  }

  // override afterGetData(model: StudentProfileModel): Promise<StudentProfileModel> {
  //   return new Promise<any>((resolve, reject) => {
  //     model.id=model.student_id;
  //     resolve(model)
  //   });
  // }

  // formatDate(dateValue) {
  //   if (!dateValue || dateValue === 0) {
  //     return '';
  //   }
  //   const formattedDate = moment(dateValue).format('DD/MM/YYYY');
  //   return moment(formattedDate, 'DD/MM/YYYY').isValid() ? formattedDate : '';
  // }

  formatDate(date: string): string {
    if (date && moment(date, moment.ISO_8601, true).isValid()) {
      return moment(date).format('MM/DD/YYYY');
    }
    return '';
  }

  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    dataModel.id = response.details.student_detail.id;
    dataModel.first_name = response.details.student_detail.first_name;
    dataModel.last_name = response.details.student_detail.last_name;
    dataModel.father_name = response.details.student_detail.father_name;
    dataModel.mother_name = response.details.student_detail.mother_name;
    dataModel.mobile_number = response.details.student_detail.mobile_number;
    dataModel.email = response.details.student_detail.email;
    dataModel.gender = this.uppercaseFirstLetter(response.details.student_detail.gender);
    dataModel.address = response.details.student_detail.address;
    dataModel.age = response.details.student_detail.age;
    // dataModel.region = this.uppercaseFirstLetter(response.details.student_detail.region);
    dataModel.region_id = response.details.student_detail.region_id;
    dataModel.state_name = response.details.student_detail.state_id;
    dataModel.name_of_college = response.details.student_detail.name_of_college;
    dataModel.college_address = response.details.student_detail.college_address;
    dataModel.branch_id = response.details.student_detail.branch_id;
    dataModel.batch_id = response.details.student_detail.batch_id;
    dataModel.unique_batch_id = response.details.student_detail.unique_batch_id;
    dataModel.mentor_name = response.details.student_detail.mentorName;
    dataModel.mentor_email = response.details.student_detail.mentor_email;
    dataModel.mentor_mobile = response.details.student_detail.mentor_mobile;
    dataModel.summer_vacation_start_date = this.formatDate(response.details.vacations.summer_vacation_start_date);
    dataModel.summer_vacation_end_date = this.formatDate(response.details.vacations.summer_vacation_end_date);
    dataModel.winter_vacation_start_date = this.formatDate(response.details.vacations.winter_vacation_start_date);
    dataModel.winter_vacation_end_date = this.formatDate(response.details.vacations.winter_vacation_end_date);
    dataModel.profile_pic_path = response.details.student_detail.profile_pic_path;
    dataModel.first_year_score = response.details.yearScore.first_year_score;
    dataModel.first_year2_score = response.details.yearScore.first_year2_score;
    dataModel.second_year_score = response.details.yearScore.second_year_score;
    dataModel.second_year2_score = response.details.yearScore.second_year2_score;
    dataModel.third_year_score = response.details.yearScore.third_year_score;
    dataModel.third_year2_score = response.details.yearScore.third_year2_score;
    dataModel.fourth_year_score = response.details.yearScore.fourth_year_score;
    dataModel.fourth_year2_score = response.details.yearScore.fourth_year2_score;
    dataModel.batch_duration_start = response.details.student_detail.batch_duration_start;
    dataModel.studentAchievementDetails = response.details.studentAchievementDetails;
    // console.log(dataModel.studentAchievementDetails);

    dataModel.placement_company_name = response.details.student_detail.placement_company_name;
    dataModel.placement_company_location = response.details.student_detail.placement_company_location;
    dataModel.placement_company_designation = response.details.student_detail.placement_company_designation;
    dataModel.placement_company_package = response.details.student_detail.placement_company_package;
    dataModel.placement_company_package = response.details.student_detail.placement_company_package;
    dataModel.placement_company_type = response.details.student_detail.placement_company_type;
    dataModel.first_year_credit = response.details.credits.first_year_credit;
    dataModel.second_year_credit = response.details.credits.second_year_credit;
    dataModel.third_year_credit = response.details.credits.third_year_credit;
    dataModel.fourth_year_credit = response.details.credits.fourth_year_credit;
    dataModel.studentDocumentDetails = response.studentDocumentDetails;
    dataModel.apiStudentDocumentDetailsList = response.details.studentDocumentDetails;
    dataModel.year = 1;
    dataModel.industryType = 1;
    dataModel.semester = 1;
    dataModel.parentMobileNumber = response.details.student_detail.parentMobileNumber === 'null' ? null : response.details.student_detail.parentMobileNumber;
    dataModel.state_id = response.details.student_detail.state_id;
    dataModel.district_id = response.details.student_detail.district_id;
    dataModel.batch_number = response.details.student_detail.batch_number;
    // dataModel.region = this.uppercaseFirstLetter(response.details.student_detail.region);
    // dataModel.branch_name = response.details.student_detail.branch_id;
    dataModel.ktsem1 = response.details.student_detail.ktsem1;
    dataModel.ktsem2 = response.details.student_detail.ktsem2;
    dataModel.ktsem3 = response.details.student_detail.ktsem3;
    dataModel.ktsem4 = response.details.student_detail.ktsem4;
    dataModel.ktsem5 = response.details.student_detail.ktsem5;
    dataModel.ktsem6 = response.details.student_detail.ktsem6;
    dataModel.ktsem7 = response.details.student_detail.ktsem7;
    dataModel.ktsem8 = response.details.student_detail.ktsem8;
    dataModel.id = response.details.student_detail.user_id
    dataModel.other = response.details.student_detail.other;

    // dataModel.studentDocumentDetails = response.studentDocumentDetails.map(doc => ({
    //   documentTypeId: doc.documentTypeId,
    //   documentName: doc.documentName,
    //   fileName: doc.UploadedFileName,
    //   filePath: '', // You might want to add a file path if available
    //   uploadedFileOriginalName: doc.UploadedFileOriginalName,
    //   isAnnual: doc.isAnnual,
    //   periodValue: doc.periodValue,
    //   uploadDocId: doc.UploadDocID,
    //   student_id: doc.student_id
    // }));

    // dataModel.apiStudentDocumentDetailsList = dataModel.studentDocumentDetails;


    return dataModel;

    // this.mergeArrays()
  }
  uppercaseFirstLetter(str: string) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<StudentProfileModel> {
    return new Promise<any>((resolve, reject) => {
      const submitData: any = new studentDetailsForm();
      submitData.first_name = model.first_name;
      submitData.last_name = model.last_name;
      submitData.father_name = model.father_name;
      submitData.mother_name = model.mother_name;
      submitData.mobile_number = model.mobile_number;
      submitData.parentMobileNumber = model.parentMobileNumber;
      submitData.email = model.email;
      submitData.address = model.address;
      submitData.gender = model.gender;
      submitData.age = model.age;
      // submitData.date_of_birth = model.date_of_birth;
      submitData.college_address = model.college_address;

      if ((model.profile_pic_path instanceof File)) {
        submitData.profile_pic_path = model.profile_pic_path;
      };

      submitData.state_id = model.state_id;
      submitData.summer_vacation_start_date = moment(model.summer_vacation_start_date).format('YYYY-MM-DD');
      submitData.summer_vacation_end_date = moment(model.summer_vacation_end_date).format('YYYY-MM-DD');
      submitData.winter_vacation_start_date = moment(model.winter_vacation_start_date).format('YYYY-MM-DD');
      submitData.winter_vacation_end_date = moment(model.winter_vacation_end_date).format('YYYY-MM-DD');
      submitData.first_year_score = model.first_year_score;
      submitData.second_year_score = model.second_year_score;
      submitData.third_year_score = model.third_year_score;
      submitData.fourth_year_score = model.fourth_year_score;
      submitData.first_year2_score = model.first_year2_score;
      submitData.second_year2_score = model.second_year2_score;
      submitData.third_year2_score = model.third_year2_score;
      submitData.fourth_year2_score = model.fourth_year2_score;
      submitData.fee_receipt = model.fee_receipt;
      submitData.first_year_credit = model.first_year_credit;
      submitData.second_year_credit = model.second_year_credit;
      submitData.third_year_credit = model.third_year_credit;
      submitData.fourth_year_credit = model.fourth_year_credit;
      submitData.placement_company_package = model.placement_company_package;
      submitData.placement_company_name = model.placement_company_name;
      submitData.placement_company_location = model.placement_company_location;
      submitData.placement_company_designation = model.placement_company_designation;
      submitData.placement_company_type = model.placement_company_type;
      submitData.region_id = model.region_id;
      submitData.name_of_college = model.name_of_college;
      submitData.unique_batch_id = model.unique_batch_id;
      submitData.district_id = model.district_id;
      submitData.id = model.id;
      submitData.other = model.other;
      submitData.branch_id = model.branch_id;
      submitData.user_id = model.id

      // console.log(model);

      model.studentAchievementDetailsForm.forEach((item, index) => {


        submitData[`achivements[${index}][aid]`] = item.achievementId;
        submitData[`achivements[${index}][atitle]`] = item.title;
        submitData[`achivements[${index}][afile]`] = item.fileOriginalName;

      })
     
      metamodel.properties.allUploadDocs.forEach((item: any, index: any) => {
        // console.log(item);

        if (item.uploadedFileOriginalName) {
          submitData[`doc[${index}][isAnnual]`] = item.isAnnual;
          submitData[`doc[${index}][documentTypeId]`] = item.documentTypeId;
          submitData[`doc[${index}][uploadDocId]`] =
            item.uploadDocId === null ? '' : item.uploadDocId;
          if (item.uploadedFileOriginalName instanceof File) {
            submitData[`doc[${index}][docFile]`] =
              item.uploadedFileOriginalName;
          }
          submitData[`doc[${index}][periodValue]`] = item.periodValue;
        }
      });

      // model.semiAnnualDocumentDetailsForm.forEach((item: any, index: any) => {
      //   // console.log(item);

      //   if (item.uploadedFileOriginalName) {
      //     submitData[`doc[${index}][isAnnual]`] = item.isAnnual;
      //     submitData[`doc[${index}][documentTypeId]`] = item.documentTypeId;
      //     submitData[`doc[${index}][uploadDocId]`] =
      //       item.uploadDocId === null ? '' : item.uploadDocId;
      //     if (item.uploadedFileOriginalName instanceof File) {
      //       submitData[`doc[${index}][docFile]`] =
      //         item.uploadedFileOriginalName;
      //     }
      //     submitData[`doc[${index}][periodValue]`] = item.periodValue;
      //   }
      // });


      // submitData.doc = this.mapPostAnnualData(metamodel.properties.postAnnualData);
      // submitData.doc = metamodel.properties.postAnnualData.forEach((postAnnualData, index) => {
      //   submitData.append(`doc[${index}][isAnnual]`, postAnnualData.isAnnual);
      //   submitData.append(`doc[${index}][documentTypeId]`, postAnnualData.documentTypeId);
      //   submitData.append(`doc[${index}][uploadDocId]`, postAnnualData.uploadDocId);
      //   submitData.append(`doc[${index}][uploadDocFile]`, postAnnualData.uploadedFileOriginalName);
      //   submitData.append(`doc[${index}][periodValue]`, postAnnualData.periodValue);
      // });
      resolve(this.convertFormData(submitData));
    });
  }

  // mapPostAnnualData(postAnnualData) {
  //   let requests = [];

  //   Object.keys(postAnnualData).forEach((period, periodIndex) => {
  //     postAnnualData[period].forEach((doc, docIndex) => {

  //       let mappedDoc = {
  //         [`doc[${docIndex}][isAnnual]`]: doc.isAnnual,
  //         [`doc[${docIndex}][documentTypeId]`]: doc.documentTypeId,
  //         [`doc[${docIndex}][uploadDocId]`]: doc.uploadDocId,
  //         [`doc[${docIndex}][uploadDocFile]`]: doc.uploadedFileOriginalName,
  //         [`doc[${docIndex}][periodValue]`]: doc.periodValue
  //       };
  //       requests.push(mappedDoc);
  //     });
  //   });
  //   return requests;
  // }

  postLoginData(data, url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService
        .postData(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }


  override afterPostData(
    model: StudentProfileModel,
    response
  ): Promise<StudentProfileModel> {
    return new Promise<StudentProfileModel>((resolve, reject) => {
      console.log(response);
      const currentProfile = this.systemService.getProfile();
      if (response.status === 'Success' && currentProfile.role === 2 && currentProfile.status === 3) {
        currentProfile.isProfileUpdateFlag = 1;
        this.ss.setlocalStorage('loginData', JSON.stringify(currentProfile));
      }
      resolve(this.transformAPIData(model));
    }).catch((err) => {
      throw err;
    });
  }

  createInstance(): StudentProfileModel {
    return new StudentProfileModel();
  }
}

export { FormDataService };
